import {
  fetchMentorClassActionplanCounts,
  fetchMentorClassActionplanFilters,
  fetchMentorClassActionplans,
} from "classroom/api/teacher";
import {
  createActionplanListStore,
  requireActionplanContext,
} from "actionplan/stores/createActionplanListStore";

export const useClassroomMentorClassActionplanStore = createActionplanListStore(
  "classroomMentorClassActionplan",
  {
    fetchList: (params, mentorClass) =>
      fetchMentorClassActionplans(
        requireActionplanContext(mentorClass),
        params,
      ),
    fetchCounts: (params, mentorClass) =>
      fetchMentorClassActionplanCounts(
        requireActionplanContext(mentorClass),
        params,
      ),
    fetchFilters: (mentorClass) =>
      fetchMentorClassActionplanFilters(requireActionplanContext(mentorClass)),
  },
);
